/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { Button, Modal } from '@atoms';

import s from './styles.module.less';

const Heading = ({ children, className, ...props }) => (
  <div className={clsx(s.heading, className)} {...props}>
    {children}
  </div>
);

const MediaLibraryModal = ({
  children,
  hide,
  loading,
  onOk,
  okDisabled,
  okHidden,
  okText = 'NEXT',
  onCancel = hide,
  cancelText = 'CANCEL',
  ...props
}) => (
  <Modal
    className={s.custom}
    footer={
      <>
        {!okHidden && (
          <Button
            className={s.okButton}
            type="primary"
            onClick={onOk}
            loading={loading}
            disabled={okDisabled || loading}
          >
            {okText}
          </Button>
        )}
        <Button onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>
      </>
    }
    {...props}
    title={null}
  >
    {props.visible && children}
  </Modal>
);

MediaLibraryModal.Heading = Heading;
MediaLibraryModal.Title = Modal.Title;
MediaLibraryModal.HeroImage = Modal.HeroImage;

export default MediaLibraryModal;
